/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const intentsPageMessages = defineMessages({
    pageTitle: {
        id: 'luis.intentsPage.pageTitle',
        defaultMessage: 'Intents'
    },
    pageTitleDescription: {
        id: 'luis.intentsPage.pageTitleDescription',
        defaultMessage: 'Intents are how LUIS determines what a user wants to do.'
    },
    renameIntent: {
        id: 'luis.intentsPage.renameIntent',
        defaultMessage: 'Rename Intent'
    },
    createIntentToastStart: {
        id: 'luis.intentsPage.createIntentToastStart',
        defaultMessage: 'Creating intent ...'
    },
    createIntentToastSuccess: {
        id: 'luis.intentsPage.createIntentToastSuccess',
        defaultMessage: 'Create intent completed'
    },
    createIntentToastFailed: {
        id: 'luis.intentsPage.createIntentToastFailed',
        defaultMessage: 'Create intent failed'
    },
    deleteIntentToastStart: {
        id: 'luis.intentsPage.deleteIntentToastStart',
        defaultMessage: 'Deleting intent(s) ...'
    },
    deleteIntentToastSuccess: {
        id: 'luis.intentsPage.deleteIntentToastSuccess',
        defaultMessage: 'Delete intent(s) completed'
    },
    deleteIntentToastFailed: {
        id: 'luis.intentsPage.deleteIntentToastFailed',
        defaultMessage: 'Delete intent(s) failed'
    },
    renameIntentToastStart: {
        id: 'luis.intentsPage.renameIntentToastStart',
        defaultMessage: 'Renaming intent ...'
    },
    renameIntentToastSuccess: {
        id: 'luis.intentsPage.renameIntentToastSuccess',
        defaultMessage: 'Rename intent completed'
    },
    renameIntentToastFailed: {
        id: 'luis.intentsPage.renameIntentToastFailed',
        defaultMessage: 'Rename intent failed'
    },
    addIntentToastStart: {
        id: 'luis.intentsPage.addIntentToastStart',
        defaultMessage: 'Adding  intent ...'
    },
    addIntentToastSuccess: {
        id: 'luis.intentsPage.addIntentToastSuccess',
        defaultMessage: 'Add intent completed'
    },
    addIntentToastFailed: {
        id: 'luis.intentsPage.addIntentToastFailed',
        defaultMessage: 'Add intent failed'
    }
});
